import { c as _c } from "react/compiler-runtime";
import { ReceiverTypes, type PaymentMethods } from 'api-graphql-types';
import { entriesOf, isNotNullOrUndefined, stringify } from 'betterplace-utils';
import analytics, { getDonationFormType } from 'product-analytics';
import { useCallback } from 'react';
import type { DonationFormValues } from '@/donationForm/types';
import { usePaymentMethodsToRender } from '@/donationPages/_dependencies/NativePaymentMethods';
import { useStep } from '@/donationPages/iframe/[receiver-type]/[slug]/_dependencies/IFrameLayout/StepProvider';
import type { ErrorHandler } from '@/form/ActionForm/useActionForm';
type UseMinimalErrorHandlerProps = {
  receiverId: string;
  receiverType: ReceiverTypes;
  showCodonation: boolean;
  channel: string;
  setBusy: (busy: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: any;
};
export function useMinimalErrorHandler() {
  const $ = _c(3);
  const {
    setStep
  } = useStep();
  const {
    paymentMethodsToRender
  } = usePaymentMethodsToRender();
  let t0;
  if ($[0] !== paymentMethodsToRender || $[1] !== setStep) {
    t0 = t1 => {
      const {
        receiverId,
        receiverType,
        showCodonation,
        channel,
        setBusy,
        errors
      } = t1;
      setStep(1);
      setBusy(false);
      analytics.donationErrorMessageDisplayed({
        donation_form_type: getDonationFormType({
          receiverId,
          receiverType,
          channel,
          showCodonation
        }),
        id: receiverId,
        receiver_type: receiverType,
        error: stringify(errors),
        errors,
        available_payment_methods: paymentMethodsToRender as PaymentMethods[]
      });
    };
    $[0] = paymentMethodsToRender;
    $[1] = setStep;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function useErrorHandler() {
  const $ = _c(2);
  const minimalHandler = useMinimalErrorHandler();
  let t0;
  if ($[0] !== minimalHandler) {
    t0 = (errors, values, t1, t2) => {
      const {
        setValue,
        setBusy,
        setError
      } = t1;
      const options = t2 === undefined ? {} : t2;
      if (options.shouldSetErrors) {
        for (const [key, error] of entriesOf(errors)) {
          const {
            message
          } = error;
          if (!isNotNullOrUndefined(message)) {
            continue;
          }
          setError(key, {
            message,
            type: "server"
          });
          if (key === "root" || key === "") {
            continue;
          }
          const value = values[key];
          setValue(key, value, {
            shouldTouch: true
          });
        }
      }
      minimalHandler({
        receiverId: values.receiver_id,
        receiverType: values.receiver_type,
        showCodonation: values.show_codonation,
        channel: values.channel,
        setBusy,
        errors
      });
    };
    $[0] = minimalHandler;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handler = t0;
  return handler;
}
export default useErrorHandler;